import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 8793E254-1126-4A01-937C-C1827F173538
 * name arrow-u-left-bottom-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-left-bottom-bold.svg
 * tags
 */
export const ArrowULeftBottomBoldIcon = createSvgIcon(<><path d="M21 10.5C21 14.64 17.64 18 13.5 18H11V22L4 16L11 10V14H13.5C15.43 14 17 12.43 17 10.5S15.43 7 13.5 7H6V3H13.5C17.64 3 21 6.36 21 10.5Z" /></>, 'ArrowULeftBottomBoldIcon');
export default ArrowULeftBottomBoldIcon